import { Editor, Transforms } from 'slate';
import { isBlockActive, isList, isListType } from '../helpers';
import { BlockType } from '../types';

// (Un-)set 'block' element types accordingly
export const toggleBlock = (editor: Editor, blockType: BlockType): void => {
	Transforms.unwrapNodes(editor, {
		match: isList,
		split: true,
	});

	const isActive = isBlockActive(editor, blockType);
	const isListBlock = isListType(blockType);

	Transforms.setNodes(editor, {
		type: isActive ? 'paragraph' : isListBlock ? 'list-item' : blockType,
	});

	if (!isActive && isListBlock) {
		const block = { type: blockType, children: [] };
		Transforms.wrapNodes(editor, block);
	}
};
